module.exports = __webpack_public_path__ + "static/media/Top-Searches.853884bd.png";